import { render } from "./ExamDetailPage.vue?vue&type=template&id=cc44bbc0&scoped=true"
import script from "./ExamDetailPage.vue?vue&type=script&lang=js"
export * from "./ExamDetailPage.vue?vue&type=script&lang=js"

import "./ExamDetailPage.vue?vue&type=style&index=0&id=cc44bbc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc44bbc0"]])

export default __exports__